// src/components/CustomModal.js
import React from 'react';
import SVGIcon from "../../components/DynamicIcon";
import './CustomModal.scss';

const CustomModal = ({ show, onClose, onGenerate, onLater, message }) => {

    if (!show) {
        return null;
    } else {
        document.body.classList.add('glloading');
    }

    return (
        <div className="custom-modal-overlay">
            <div className="custom-modal-content">
                <div className='modal-content-inside'>
                    <div className="custom-modal-header">
                        <div className="modal-checkmark">
                            <SVGIcon name="greenTick" width={24} height={24} />
                        </div>
                        <div className="custom-modal-body">
                            Form Saved Successfully!
                        </div>
                    </div>

                    <div className='custom-modal-body-content'> {message || "Do you want to download pdf?"}</div>
                    <div className="custom-modal-footer">
                        <button onClick={onLater} className="btn-later">Cancel</button>
                        <button onClick={onGenerate} className="btn-generate">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;